module.exports = "<div class=clearfix> <div class=qrcode> <qrcode data={{$ctrl.product.ShareLink}} version=7 size=75></qrcode> <md-tooltip md-direction=top> لینک محصول رو توسط QRCode خوان اسکن کن </md-tooltip> </div> <div class=brand> <a ng-href={{$ctrl.product.ManufacturerUrl}}> <span class=image> <img ng-src={{$ctrl.product.ManufacturerImage}} alt={{$ctrl.product.ManufacturerName}} /> </span> </a> <md-tooltip md-direction=top> مشاهده محصولات برند {{$ctrl.product.ManufacturerName}} </md-tooltip> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/product-info-footer/product-info-footer.template.html
// module id = 100
// module chunks = 3